import { GiphyFetch } from '@giphy/js-fetch-api';
import { IGif } from '@giphy/js-types';
import { Grid } from '@giphy/react-components';
import Image from 'next/image';
import { useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import poweredByGiphyImage from '../../../../assets/images/PoweredBy_200px-White_HorizText.png';
import theme from '../../../../assets/theme';
import { useMetrics } from '../../../../hooks/useMetrics';
import { Switch } from '../../../_atoms/_Switch';
import SearchInput from '../../../_molecules/SearchInput';

const giphyFetch = new GiphyFetch('fG3fCsjdKR7IQXZIkjSSQwqxu6tq8Jns'); // TODO: add this as env variable

const GiphyPicker = ({
  onGifSelected,
}: {
  onGifSelected: (gifId: string, width: number, height: number) => void;
}) => {
  const metrics = useMetrics();
  const gridContainerRef = useRef<HTMLDivElement>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [transparentSelected, setTransparentSelected] = useState(false);

  const fetchGifs = (offset: number) => {
    if (searchTerm.length === 0 && !transparentSelected) {
      return giphyFetch.trending({ offset, limit: 10 });
    }
    const toSearchWith = transparentSelected ? `transparent ${searchTerm}` : searchTerm;
    return giphyFetch.search(toSearchWith, {
      offset,
      sort: 'relevant',
      limit: 10,
      rating: 'g',
    });
  };

  const [gridWidth, setGridWidth] = useState(0);
  useLayoutEffect(() => {
    setGridWidth(gridContainerRef.current?.offsetWidth || 0);
  }, []);

  const handleGIFClicked = (gif: IGif) => {
    const { width, height } = gif.images.original;

    onGifSelected(`${gif.id}`, width, height);
  };

  const { t } = useTranslation('Host');
  return (
    <CenteredDiv>
      <div style={{ padding: '0px 20px', marginBottom: 6 }}>
        <SearchInput
          value={searchTerm}
          placeholder={`${t('Search GIFs from Giphy')}`}
          onChange={setSearchTerm}
          style={{ width: '100%' }}
        />
      </div>

      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 5,
        }}
      >
        <Image height={15} width={150} alt="Powered by Giphy" src={poweredByGiphyImage} />
        <div
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={() => {
            metrics.logEvent('Creator.Media.Giphy.Transparent.Clicked');
            setTransparentSelected(e => !e);
          }}
        >
          <Switch color={theme.colors.blue} value={transparentSelected} />{' '}
          <span style={{ marginLeft: '8px' }}>{t('Transparent')}</span>
        </div>
      </div>

      <div
        style={{
          width: '100%',
          padding: '0px 20px',
          height: 'calc(100% - 75px)',
          overflowY: 'auto',
        }}
      >
        <div
          ref={gridContainerRef}
          style={{
            width: '100%',
            height: '100%',
          }}
        >
          <Grid
            onGifClick={(gif, e) => {
              e.preventDefault();
              handleGIFClicked(gif);
            }}
            hideAttribution={false}
            key={transparentSelected ? `transparent ${searchTerm}` : searchTerm}
            width={gridWidth}
            columns={2}
            fetchGifs={fetchGifs}
          />
        </div>
      </div>
    </CenteredDiv>
  );
};

export default GiphyPicker;

const CenteredDiv = styled.div`
  width: 100%;
  height: 100%;
`;
